export const ALL_DRIVERS: number = -1;
export const UNASSIGNED: number = null;
export const DATE_FORMAT = 'MMM DD, LT';
